import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LoginComponent } from './components/login/login.component'
import { ModalModule } from 'ngx-bootstrap/modal'
import { AngularDualListBoxModule } from 'angular-dual-listbox'
import { AccordionModule } from 'ngx-bootstrap/accordion'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { PaginationModule } from 'ngx-bootstrap/pagination'
import { ProgressbarModule } from 'ngx-bootstrap/progressbar'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { StoreModule } from '@ngrx/store'
import { appReducer } from './store/reducer/app.reducer'
import { EffectsModule } from '@ngrx/effects'
import { LoginEffects } from './store/effect/login.effect'
import { ToastrModule } from 'ngx-toastr'
import { DashboardEffects } from './store/effect/dashboard.effect'
import { DashboardComponent } from './components/dashboard/dashboard.component'
import { AuthInterceptor } from './services/interceptor/auth.interceptor'
import { ActivityDashboardComponent } from './components/activity/dashboard/activity-dashboard.component'
import { HeaderComponent } from './components/common/header/header.component'
import { ActivityEffects } from './store/effect/activity.effect'
import { StatsCardComponent } from './components/common/stats-card-group/stats-card/stats-card.component'
import { ViewForSelectionComponent } from './components/common/view-for-selection/view-for-selection.component'
import { DashboardSummaryTableComponent } from './components/common/dashboard-summary-table/dashboard-summary-table.component'
import { GreetingComponent } from './components/common/greeting/greeting.component'
import { CreateActivityComponent } from './components/activity/create-activity/create-activity.component'
import { CommonEffects } from './store/effect/common.effect'
import { ValidationComponent } from './components/common/validation/validation.component'
import { InitializeEffects } from './store/effect/initialize.effect'
import { CategorySelectorComponent } from './components/common/category-selector/category-selector.component'
import { QueryDashboardComponent } from './components/query/query-dashboard/query-dashboard.component'
import { QueryEffects } from './store/effect/query.effect'
import { VarDirective } from './directives/ng-var.directive'
import { CreateQueryComponent } from './components/query/create-query/create-query.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { LogoutEffects } from './store/effect/logout.effect'
import { SideNavComponent } from './components/common/side-nav/side-nav.component'
import { SettingsComponent } from './components/settings/settings.component'
import { KnowledgeQuickSelectComponent } from './components/knowledge/quick-select/knowledge-quick-select.component'
import { ProfileComponent } from './components/profile/profile.component'
import { EmployeeEffects } from './store/effect/employee.effect'
import { DatePipe } from '@angular/common'
import { ViewInfoComponent } from './components/view-info/view-info/view-info.component'
import { MatCardModule } from '@angular/material/card'
import { StatsCardGroupComponent } from './components/common/stats-card-group/stats-card-group.component'
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { CalendarModule, DateAdapter } from 'angular-calendar'
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'
import { CustomWeekHeaderComponent } from './custom-week-header/custom-week-header.component'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { environment } from '../environments/environment'
import { ActivityDetailsComponent } from './components/activity/activity-details/activity-details.component'
import { CommentComponent } from './components/common/comment/comment.component'
import { QueryDetailsComponent } from './components/query/query-details/query-details.component'
import { MultipleFileSelectorComponent } from './components/common/multiple-file-selector/multiple-file-selector.component'
import { PasswordInputComponent } from './components/common/password-input/password-input.component'
import { ViewKnowledgeArticleComponent } from './components/knowledge/view-knowledge-article/view-knowledge-article.component'
import { KnowledgeSearchComponent } from './components/knowledge/knowledge-search/knowledge-search.component'
import { ChangePasswordComponent } from '../app/components/change-password/change-password.component'
import { KnowledgeSummaryComponent } from './components/knowledge/knowledge-summary/knowledge-summary.component'
import { SummaryDataTableComponent } from './components/common/summary-data-table/summary-data-table.component'
import { KnowledgeEffects } from './store/effect/knowledge.effect'
import { SafeUrlPipe } from './components/pipe/safeUrl.pipe'
import { Form11Component } from './components/form11/form11.component'
import { Form11SidebarComponent } from './components/form11-sidebar/form11-sidebar.component'
import { AttachmentListComponent } from './components/common/attachment-list/attachment-list.component'
import { TutorialInfoComponent } from './components/help-info/tutorial-info/tutorial-info.component'
import { FeedbackEffects } from './store/effect/feedback.effect'
import { AutoHeightDirective } from './directives/auto-height.directive'
import { ActivitySummaryComponent } from './components/activity/summary/activity-summary.component'
import { BackButtonComponent } from './components/common/back-button/back-button.component'
import { QuerySummaryComponent } from './components/query/query-summary/query-summary.component'
import { FeedbackResponseComponent } from './components/feedback/feedback-response.component'
import { DocumentPreviewComponent } from './components/common/document-preview/document-preview.component'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { NewJoineeWorkflowNotificationPopupComponent } from './components/new-joinee-workflow-notification-popup/new-joinee-workflow-notification-popup.component'
import { PendingFromEmployeeQueryNotificationPopupComponent } from './components/pending-from-employee-query-notification-popup/pending-from-employee-query-notification-popup.component'
import { DynamicModalComponent } from './components/common/dynamic-modal/dynamic-modal.component'
import { NgOtpInputModule } from 'ng-otp-input'
import { LandingComponent } from './components/landing/landing.component'

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    ActivityDashboardComponent,
    HeaderComponent,
    StatsCardComponent,
    ViewForSelectionComponent,
    DashboardSummaryTableComponent,
    GreetingComponent,
    CreateActivityComponent,
    ValidationComponent,
    CategorySelectorComponent,
    QueryDashboardComponent,
    VarDirective,
    CreateQueryComponent,
    SideNavComponent,
    SettingsComponent,
    KnowledgeQuickSelectComponent,
    StatsCardGroupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ProfileComponent,
    ViewInfoComponent,
    StatsCardGroupComponent,
    ActivityDetailsComponent,
    CustomWeekHeaderComponent,
    CommentComponent,
    QueryDetailsComponent,
    CustomWeekHeaderComponent,
    QueryDetailsComponent,
    MultipleFileSelectorComponent,
    PasswordInputComponent,
    ViewKnowledgeArticleComponent,
    KnowledgeSearchComponent,
    ChangePasswordComponent,
    KnowledgeSummaryComponent,
    SummaryDataTableComponent,
    SafeUrlPipe,
    Form11Component,
    Form11SidebarComponent,
    AttachmentListComponent,
    TutorialInfoComponent,
    AutoHeightDirective,
    ActivitySummaryComponent,
    BackButtonComponent,
    QuerySummaryComponent,
    FeedbackResponseComponent,
    DocumentPreviewComponent,
    NewJoineeWorkflowNotificationPopupComponent,
    PendingFromEmployeeQueryNotificationPopupComponent,
    DynamicModalComponent,
    LandingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatCardModule,
    ReactiveFormsModule,
    FormsModule,
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    AngularDualListBoxModule,
    ModalModule.forRoot(),
    HttpClientModule,
    StoreModule.forRoot(appReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 100,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([
      LoginEffects,
      DashboardEffects,
      ActivityEffects,
      CommonEffects,
      InitializeEffects,
      QueryEffects,
      LogoutEffects,
      EmployeeEffects,
      KnowledgeEffects,
      FeedbackEffects
    ]),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    MatAutocompleteModule,
    FormsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    FormsModule,
    PdfViewerModule,
    NgOtpInputModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
